export default __webpack_public_path__ + "static/media/code-editor.6cf2e09a.svg";